import React from "react"
import "../../styles/Benefits/Background.less"
import benifitsJson from "../../Configs/JSON/benifits.json"
import { Typography } from "antd"
import AppStore from "../../Configs/Store/index"
import { observer } from "mobx-react"
import DOMPurify from "dompurify"
const { Paragraph } = Typography

const Background = observer(({ personaType = "Wealth", ...props }) => {
  // const getDimension = useStoreState((state) => state.dimension)
  const [expand, setExpand] = React.useState(false)

  return (
    <>
      <div className="AlertTitle">
        {AppStore.device === 0 ? (
        <>
          <div className="AlertPara">
            <p>{expand ? benifitsJson["Background"][personaType]["topPara1"] : benifitsJson["Background"][personaType]["topPara2"]}</p>
            <p className={"AlertReadMoreBtn"} onClick={()=>setExpand(!expand)}>{expand ? `....Less` : `...Read More` }</p>
          </div>
        </>
        ) : (
          <div className="AlertPara">{benifitsJson["Background"][personaType]["topPara1"]}</div>
        )}
        <div className="AlertBox">
        <div className="AlerttopTitle"dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(benifitsJson['Background'][personaType]['topTitle'])}}/>
        <div className="AlertSubTitle"dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(benifitsJson['Background'][personaType]['subtopTitle'])}}/>
        </div>
      </div>
      <div className="GuaranteedIncome_Background">{props.children}</div>
    </>
  )
})

export default Background
